import React, { useEffect, useState } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { getMetricUnitByKey } from '@utils/metrics';
import { humanize } from '@utils';
import { getHighlightedText } from '../utils';
import { StyledCodeBlock, StyledPanel, StyledSearch, StyledTable } from '../styled';

const getColumns = (columns: any, dimension: string, dimensionDetails: any) => {
  return columns.reduce((result, column: any) => {
    const { key, title, dataKey } = column;
    if (key !== 'action') {
      result.push({
        title: dataKey === 'name' ? dimensionDetails.name : title,
        dataIndex: key,
        key,
        ellipsis: true,
        sorter:
          dataKey !== 'name'
            ? (a: any, b: any) => {
                if (a[key] === 'NA' || b[key] === 'NA') {
                  return 0;
                }
                return a[key] - b[key];
              }
            : undefined,
        width: key === dimension ? '400px' : '100px',
        render: (text: string) => {
          const metricUnit = getMetricUnitByKey({ metricKey: key });
          if (key !== dimension) {
            return <span>{text !== 'NA' ? humanize(text, metricUnit) : 'NA'}</span>;
          }
          return <span>{text}</span>;
        },
      });
    }
    return result;
  }, []);
};

const ExplorePanel = ({ dimension, data, columns, dimensionDetails }) => {
  const [tableData, setTableData] = useState(data);
  const [searchText, setSearchText] = useState('');
  const detailedColumn = getColumns(columns, dimension, dimensionDetails);

  useEffect(() => {
    const filteredData = data.filter((d: any) =>
      d[dimension].toLowerCase().includes(searchText.toLowerCase()),
    );
    setTableData(filteredData);
  }, [data, dimension, searchText]);

  const onSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };

  return (
    <StyledPanel>
      <StyledSearch
        placeholder={`Search for ${dimensionDetails.name}`}
        allowClear
        onChange={onSearch}
      />
      <StyledTable
        columns={detailedColumn}
        expandable={{
          columnWidth: 50,
          expandRowByClick: true,
          expandedRowRender: (record) => {
            const highlightedData = getHighlightedText(record[dimension], searchText);
            return (
              <StyledCodeBlock>
                <pre>{highlightedData}</pre>
              </StyledCodeBlock>
            );
          },
          rowExpandable: () => true,
          expandIcon: ({ expanded, onExpand, record }) => {
            return (
              <div onClick={(e) => onExpand(record, e)}>
                {expanded ? <DownOutlined /> : <RightOutlined />}
              </div>
            );
          },
        }}
        rowKey={dimension}
        dataSource={tableData}
        pagination={false}
      />
    </StyledPanel>
  );
};

export default ExplorePanel;
